
































import { Component, Vue, Watch } from 'vue-property-decorator';
import MenuBar from '@/components/MenuBar.vue';
import VFooter from '@/components/VFooter.vue';
import VButton from './components/VButton.vue';
import store from '@/store';
import {Getter} from 'vuex-class';

@Component({
  components: {
    MenuBar,
    VFooter,
    VButton,
  },
})
export default class App extends Vue {
  @Getter('isLoggedIn', { namespace: 'account' }) private isLoggedIn!: boolean;

  private tokenInitialized = false;

  private created() {
    if (window.location.pathname.startsWith('/login/sso')) {
      const locationStrings = window.location.pathname.split('/');
      store.commit('account/LOGIN', {
        refreshToken: locationStrings[3],
      });
    }
    store.dispatch('account/refreshToken')
      .finally(() => {
        if (this.isLoggedIn) {
          store.dispatch('account/userInfo');
          store.dispatch('account/subscriptionInfo');
        }
        this.tokenInitialized = true;
      });
  }

  @Watch('$route.params.errorModal')
  private onErrorModal(value: boolean, oldValue: boolean) {
    if (value) {
      (this.$refs['show-error-modal'] as any).show();
    }
  }
}
